import React from "react"
import PropTypes from "prop-types"

import TypographLink from "shared/components/TypographLink"
import Typograph from "components/Typograph"
import Bullets from "shared/components/Bullets"

const ItemBody = ({
  onClickItem,
  protocol,
  description,
  type,
  t,
  renderOthersColumns
}) => {
  const textStatus =
    type === "progress" ? t("PROGRESS_REQUEST") : t("COMPLETED_REQUEST")

  const bullet = type === "progress" ? "neutral" : "success"

  return (
    <tr>
      <td>
        <TypographLink
          size="medium"
          weight="regular"
          preset="link"
          isExternal
          onClick={onClickItem}
        >
          {protocol}
        </TypographLink>
      </td>
      <Typograph htmlTag="td" size="medium" color="outer_space" weight="bold">
        {description}
      </Typograph>
      <td>
        <Bullets text={textStatus} type={bullet} />
      </td>
      {renderOthersColumns()}
    </tr>
  )
}

ItemBody.propTypes = {
  demand: PropTypes.object,
  onClickItem: PropTypes.func,
  protocol: PropTypes.string,
  description: PropTypes.string,
  type: PropTypes.string,
  t: PropTypes.func,
  renderOthersColumns: PropTypes.func
}

export default ItemBody



// WEBPACK FOOTER //
// ./src/scenes/IncidentManager/components/Requests/ItemBody.js